import { render, staticRenderFns } from "./price.vue?vue&type=template&id=374af876"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextTooltip: require('/usr/src/app/components/text/tooltip.vue').default,ButtonAddToCart: require('/usr/src/app/components/button/add-to-cart.vue').default})
